import theme from "@configs/theme";
import { useTheme } from "react-native-paper";

const finalTheme = theme(false);
export type AppTheme = typeof finalTheme;

export const useAppTheme = () => useTheme<AppTheme>();
